package com.iregained.eventapp.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import com.iregained.eventapp.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowRightFromBracket
import com.varabyte.kobweb.silk.components.icons.fa.FaCalendar
import com.varabyte.kobweb.silk.components.icons.fa.FaChartLine
import com.varabyte.kobweb.silk.components.icons.fa.FaUsers
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import kotlinx.browser.window
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

@Composable
fun AdminLayout(
    staffName: String = "Staff Member", content: @Composable () -> Unit
) {
    val palette = ColorMode.current.toSitePalette()
    val scope = rememberCoroutineScope()

    Row(modifier = Modifier.fillMaxSize().minHeight(100.vh).backgroundColor(palette.custom.surfaceBackground)) {

        // --- 1. SIDEBAR ---
        Column(
            modifier = Modifier.width(250.px).fillMaxHeight().backgroundColor(palette.custom.cardBackground)
                .borderRight(1.px, LineStyle.Solid, palette.custom.neutralLight).padding(24.px)
        ) {
            SpanText(
                text = "MyHand® Admin",
                modifier = Modifier.fontSize(20.px).fontWeight(FontWeight.Bold).color(palette.custom.brandPrimary)
                    .margin(bottom = 40.px)
            )

            // Navigation Links
            SidebarLink(icon = { FaUsers() }, text = "Live Queue", path = "/admin/dashboard", isActive = true)
            SidebarLink(icon = { FaCalendar() }, text = "Event Settings", path = "/admin/settings", isActive = false)
            SidebarLink(icon = { FaChartLine() }, text = "Global Patients", path = "/admin/patients", isActive = false)

            Box(modifier = Modifier.weight(1f)) // Spacer to push logout to bottom

            // Logout Button
            Row(
                modifier = Modifier.cursor(Cursor.Pointer).onClick {
                    scope.launch {
                        try {
                            Firebase.auth.signOut() // Safely calls the suspend function

                            // 3. Only redirect AFTER sign-out completes successfully
                            window.location.href = "/admin/login"
                        } catch (e: Exception) {
                            console.error("Failed to sign out: ${e.message}")
                        }
                    }
                }, verticalAlignment = Alignment.CenterVertically
            ) {
                FaArrowRightFromBracket(modifier = Modifier.margin(right = 12.px).color(palette.custom.darkText))
                SpanText("Sign Out", modifier = Modifier.fontWeight(FontWeight.Medium).color(palette.custom.darkText))
            }
        }

        // --- 2. MAIN CONTENT AREA ---
        Column(modifier = Modifier.fillMaxHeight().weight(1f)) {

            // Top Bar
            Row(
                modifier = Modifier.fillMaxWidth().height(70.px).backgroundColor(palette.custom.cardBackground)
                    .borderBottom(1.px, LineStyle.Solid, palette.custom.neutralLight).padding(leftRight = 32.px),
                verticalAlignment = Alignment.CenterVertically
            ) {
                // Event Switcher Placeholder
                Column {
                    SpanText("Active Event", modifier = Modifier.fontSize(12.px).color(palette.custom.darkText))
                    SpanText(
                        "Toronto Hand Rehab 2026 ▼",
                        modifier = Modifier.fontWeight(FontWeight.Bold).cursor(Cursor.Pointer)
                    )
                }

                Box(modifier = Modifier.weight(1f))

                // User Profile Context
                SpanText("Welcome, $staffName", modifier = Modifier.fontWeight(FontWeight.Medium))
            }

            // Injected Page Content
            Box(modifier = Modifier.fillMaxSize().padding(32.px)) {
                content()
            }
        }
    }
}

@Composable
fun SidebarLink(icon: @Composable () -> Unit, text: String, path: String, isActive: Boolean) {
    val palette = ColorMode.current.toSitePalette()
    Link(path = path, modifier = Modifier.margin(bottom = 24.px).fillMaxWidth()) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Box(
                modifier = Modifier.margin(right = 12.px)
                    .color(if (isActive) palette.custom.brandPrimary else palette.custom.darkText)
            ) {
                icon()
            }
            SpanText(
                text,
                modifier = Modifier.fontWeight(if (isActive) FontWeight.Bold else FontWeight.Medium)
                    .color(if (isActive) palette.custom.brandPrimary else palette.custom.darkText)
            )
        }
    }
}